import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import UserRow from 'users/components/UserRow';

import { toggleUser } from 'users/actions';
import { addGrowlMessage as addMsg } from 'messages/actions';
import { getPermissions, getCompany } from 'auth/selectors';

class UserRowContainer extends Component {
  // handleToggle = () =>
  //   this.props
  //     .toggleUser(this.props.company.id, this.props.user.id)
  //     .then(({ value }) => this.props.addMsg(value.message, "success", "common.success"))
  //     .catch(err => err.code !== 401 && this.props.addMsg(err.message, "danger", "common.error"));

  render = () => (
    <UserRow
      handleToggle={this.props.handleToggle}
      id={this.props.user.id}
      user={this.props.user}
      companyId={this.props.company.id}
      isLoading={this.props.user.isSaving}
      permissions={this.props.permissions}
    />
  );
}

// const mapDispatchToProps = { toggleUser, addMsg };

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
});

export default compose(connect(mapStateToProps, null))(UserRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/containers/UserRowContainer.js